module.exports = __webpack_public_path__ + "static/img/P2.2e6613e2.png";